export const apiName: string = 'bens';
export const frotasStorage: string = 'frotas';

export const frotasRoute: string = 'frotas';
export const aeronavesRoute: string = 'aeronaves';
export const embarcacoesRoute: string = 'embarcacoes';
export const equipamentosRoute: string = 'equipamenos';
export const maquinarioRoute: string = 'maquinario';
export const outrosRoute: string = 'outros';
export const veiculosRoute: string = 'veiculos';

export const aeronavesModuleName: any = {plural: 'Aeronaves', single: 'Aeronave'};
export const embarcacoesModuleName: any = {plural: 'Embarcações', single: 'Embarcação'};
export const equipamentosModuleName: any = {plural: 'Equipamentos', single: 'Equipamento'};
export const maquinarioModuleName: any = {plural: 'Maquinários', single: 'Maquinário'};
export const outrosModuleName: any = {plural: 'Outros', single: 'Outro'};
export const veiculosModuleName: any = {plural: 'Veículos', single: 'Veículo'};

export const frotaImagemApiName: string = 'imagens-bens';

export const frotasQueryComCombustivel: any = {
    "where": {
        "ativo": true,
        "or": [
            {"codigo": {"regexp": "/REPLACEHERE/i"}},
            {"placa": {"regexp": "/REPLACEHERE/i"}},
            {"identificacao": {"regexp": "/REPLACEHERE/i"}}
        ]
    },
    "order": "identificacao",
    "include": ["modelo","orgao","area","divisao","setor","localidade","cor","situacao","odometroHorimetro"]
};

export const frotasQuery: any = {
    "where": {
        "and": [
            {"ativo": true},
            {
                "or": [
                    {"codigo": {"regexp": "/REPLACEHERE/i"}},
                    {"placa": {"regexp": "/REPLACEHERE/i"}},
                    {"identificacao": {"regexp": "/REPLACEHERE/i"}}
                ]
            }
        ]
    },
    "order": "identificacao",
    "include": ["modelo","orgao","area","divisao","setor","localidade","cor","situacao","odometroHorimetro"]
};

export const frotasQueryComGPS: any = {
    where: {
        gpsImei: {neq: null},
        gpsModeloId: {neq: null}
    }
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/shared/data.service.ts
 **/